import styled from 'styled-components';
import FONTS from 'constants/fonts';

const Header = styled.div`
  font-weight: 500;
  font-size: ${FONTS.H4};
  text-align: center;
`;

export default Header;
